// extracted by mini-css-extract-plugin
export default {"wrapper":"dev-tools_wrapper__tKdo4","menus":"dev-tools_menus__XnLVW","button":"dev-tools_button__yF6aH"};